// extracted by mini-css-extract-plugin
export default {"page":"UnblockCard_page__KYKEf","content":"UnblockCard_content__0cveZ","list":"UnblockCard_list__hM6Bf","card":"UnblockCard_card__j26my"};